import { useState } from "react";

import {
  IconButton,
  InputAdornment,
  RegularTextField,
  Stack,
} from "@braintrust/braintrust-ui-components";
import {
  CloseIcon,
  SearchSVGIcon,
} from "@braintrust/braintrust-ui-components/Icons";
import { useRostersFilters } from "@js/apps/rosters/hooks/use-rosters-filters";

import type { RosterVisibilityType } from "../../types";

import { RostersVisibilityFilterPopover } from "./rosters-visibility-filter-popover";

// No default MUI outline — a soft resting elevation instead of a hard
// border, and the design system's standard focus ring rather than a
// redrawn outline.
const SEARCH_FIELD_SX = {
  "& .MuiOutlinedInput-root": {
    bgcolor: "var(--white)",
    borderRadius: "0.625rem",
    transition: "box-shadow 150ms ease",
    boxShadow: "var(--elevation-2)",
  },
  "& .MuiOutlinedInput-root.Mui-focused": {
    boxShadow: "var(--box-shadow-focus)",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
};

export const RostersFilters = () => {
  const { filters, setFilters } = useRostersFilters();
  const [search, setSearch] = useState(filters.search ?? "");

  const handleSearchSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    setFilters({ search: search || null, page: undefined });
  };

  const handleClearSearch = () => {
    setSearch("");
    setFilters({ search: null, page: undefined });
  };

  return (
    <Stack
      direction="row"
      sx={{ gap: 2, flexWrap: "wrap", alignItems: "center" }}
    >
      <form onSubmit={handleSearchSubmit}>
        <RegularTextField
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          placeholder="Search by title"
          size="small"
          sx={SEARCH_FIELD_SX}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchSVGIcon sx={{ fontSize: "20px" }} />
                </InputAdornment>
              ),
              endAdornment: search ? (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="clear search"
                    onClick={handleClearSearch}
                    variant="transparent"
                    size="x-small"
                  >
                    <CloseIcon sx={{ fontSize: "13px" }} />
                  </IconButton>
                </InputAdornment>
              ) : undefined,
            },
          }}
        />
      </form>
      <RostersVisibilityFilterPopover
        visibility={filters.visibility as RosterVisibilityType | null}
        onChange={(value) => setFilters({ visibility: value, page: undefined })}
      />
    </Stack>
  );
};
